import { ReactNode, useMemo } from 'react';

import { createCtx } from '@pletly/ui';
import { useSubscriptionStatus } from './useSubscriptionStatus';

type ContextType = ReturnType<typeof useSubscriptionStatus>;

const [usePremium, PremiumDataProvider] = createCtx<ContextType>();

const PremiumProvider = ({ children }: { children?: ReactNode }) => {
	const status = useSubscriptionStatus();

	const value = useMemo(() => status, [status]);

	return <PremiumDataProvider value={value}>{children}</PremiumDataProvider>;
};

export { usePremium, PremiumProvider };
